import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { ComplaintRequest } from '../../services/complaintService';

const ComplaintDialog = ({ open, onClose, pid, type }) => {
  const { t } = useTranslation();
  const [description, setDescription] = useState('');

  const handleSubmit = async () => {
    if (!description.trim()) {
      toast.error(t('complaintForm.emptyNoteError'));
      return;
    }

    try {
      const response = await ComplaintRequest({
        pid,
        type,
        description
      });

      if (response.statusCode === 200) {
        toast.success(response.message);
        onClose();
        setDescription('');
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(t('complaintForm.error'));
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('complaintForm.title')}</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
          <TextField
            fullWidth
            multiline
            rows={4}
            label={t('complaintForm.noteLabel')}
            placeholder={t('complaintForm.notePlaceholder')}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          {t('settings.cancel')}
        </Button>
        <Button 
          onClick={handleSubmit}
          variant="contained"
          disabled={!description.trim()}
        >
          {t('complaintForm.submitButton')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ComplaintDialog; 